import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import HeaderTitle from "../HederTitle/HeaderTitle";
import { backend_url } from "../../App";
import "./Category.css";

const Category = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get(`${backend_url}/api/browsecategory`);
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  return (
    <div className="max-w-7xl mx-auto px-4 py-10 md:py-20">
      <HeaderTitle Header="Browse by category" />

      {/* Horizontal Scroll on Mobile */}
      {/* <div className="block md:hidden overflow-x-auto">
        <div className="flex space-x-6 mt-6 pb-2 w-max">
          {categories.map((category) => (
            <Link
              to={`collections/${category.routeTo}`}
              key={category._id}
              onClick={() => window.scrollTo(0, 0)}
              className="flex-shrink-0 flex flex-col items-center group"
            >
              <div className="relative w-40 h-40 sm:w-44 sm:h-44">
                <div className="absolute left-3 top-3 inset-0 bg-purple-300 rounded-lg shadow-lg scale-105"></div>
                <img crossOrigin="anonymous" 
                  src={`${category.image}`}
                  alt={category.collectionName}
                  className="relative w-full h-full object-cover rounded-lg rounded-tl-none group-hover:scale-105 transition-transform"
                />
              </div>
              <div className="mt-3 text-sm text-center font-semibold text-[#612888]">
                {category.collectionName}
              </div>
            </Link>
          ))}
        </div>
      </div> */}

      {/* Vertical list on Mobile */}
      <div className="block md:hidden overflow-y-auto">
        <div className="flex flex-col space-y-6 mt-6 pb-2 w-full">
          {categories.map((category) => (
            <Link
              to={`collections/${category.routeTo}`}
              key={category._id}
              onClick={() => window.scrollTo(0, 0)}
              className="flex-shrink-0 flex flex-col items-center group"
            >
              <div className="relative w-60 h-60 sm:w-44 sm:h-44">
                <div className="absolute left-3 top-3 inset-0 bg-purple-300 rounded-lg shadow-lg scale-105"></div>
                <img
                  crossOrigin="anonymous"
                  src={`${category.image}`}
                  alt={category.collectionName}
                  className="relative w-full h-full object-cover rounded-lg rounded-tl-none group-hover:scale-105 transition-transform"
                />
              </div>
              <div className="mt-3 text-sm text-center font-semibold text-[#612888]">
                {category.collectionName}
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* Grid Layout on Tablet and Desktop */}
      <div className="hidden md:grid grid-cols-3 lg:grid-cols-4 gap-6 mt-8">
        {categories.map((category) => (
          <Link
            to={`collections/${category.routeTo}`}
            key={category._id}
            onClick={() => window.scrollTo(0, 0)}
            className="flex flex-col items-center group"
          >
            <div className="relative w-full max-w-[220px] aspect-square">
              <div className="absolute left-3 top-3 inset-0 bg-purple-300 rounded-lg shadow-lg scale-105"></div>
              <img
                crossOrigin="anonymous"
                src={`${category.image}`}
                alt={category.collectionName}
                className="relative w-full h-full object-cover rounded-lg rounded-tl-none group-hover:scale-105 transition-transform"
              />
            </div>
            <div className="mt-4 text-center font-semibold text-base text-[#612888]">
              {category.collectionName}
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default Category;
